module.exports = __webpack_public_path__ + "img/icon_qbi.9221a5ee.jpg";